import React, { Component, createRef, Fragment } from 'react';
import { Button, Checkbox, message, Popconfirm, Typography, Row, Col, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import CpSearchBar from '../../components/CpSearchBar';
import CpLogo from '../../components/CpLogo';
import CpProductInfo from '../../components/CpProductInfo';
import CpEmpty from '../../components/CpEmpty';
import CpLoading from '../../components/CpLoading';
import ErpMapForm from '../../components/erpForm/erpMapForm';
import { amountToString, amountStrToNumber } from '../../util/tool';
import { formateErpProducts } from '../../components/erpForm/erpMapConst';
import { orderPlanTaskReserveListAddress } from '../../util/api';
import { planFormateProducts, planModifyProductNum, planMapState } from '../../util/formateProduct';
import moment from 'moment';
import send from '../../util/request';
import { queryString } from '../../util/qs';

import './style.less';

const { localStorage, history } = window;
const TransportationType = ['无', '陆运', '海运', '空运', '陆铁联运'];

export default class TransferOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectProducts: {}, // 记录选中的商品
      suppliers: {},   // 记录各个供应商的商品和选中商品数
      selectedAll: false, // 全选按钮
      totalPrice: 0,
      totalCount: 0,
      emptyStatus: '',
      loading: true,
      currentProduct: {},
      erpMap: {},
      pre_sale_goods_id: '',
      order_no: '',
      ids: [],
      plan: {},
      addressId: ''
    };
    this.columns = [
      { key: 'selectState', name: '全选', align: 'left', width: 168 },
      { key: 'product', name: '商品信息', align: 'left' },
      { key: 'unit_amount', name: '单价', align: 'right', width: 160 },
      { key: 'tax_rate', name: '税率', align: 'right', width: 160 },
      { key: 'tax_inclusive_price', name: '商品价格(含税)', align: 'right', width: 260 },
      { key: 'num', name: '数量', align: 'center', width: 200 },
      { key: 'tax_inclusive_subtotal', name: '小计', align: 'right', width: 180 },
    ];
  }


  finallyFormatProduct = (nextProps) => {
    let { shopList, ids = [] } = nextProps;
    let { suppliers, selectProducts, selectedAll, erpMap = {} } = this.state;
    const newErpMap = this.forMateErpMap(shopList, erpMap);
    if (shopList.length <= 0) {
      suppliers = {};
      selectProducts = {};
      selectedAll = false;
    } else {
      shopList.forEach(obj => {
        const { supplierId, saleList = [] } = obj;
        if (!suppliers[supplierId]) {
          suppliers[supplierId] = {
            checkNum: 0,
            productNum: saleList.filter(item => item.qoute_id).length,
            checked: false
          };
        }
        saleList.filter(item => item.qoute_id).forEach(p => {
          let o = selectProducts[p.norms_id];
          if (o) {
            o.number = p.num;
            o.total = p.num * amountStrToNumber(p.unit_amount);
            o.isOnSale = p.is_on_sale;
            o.cartId = p.cartId;
            o.saleId = p.id;
            o.unit = p.unit;
            o.pre_sale_goods_id = p.pre_sale_goods_id;
            o.tax_inclusive_subtotal = p.tax_inclusive_subtotal;
            o.qoute_id = p.qoute_id;
          }
        });
      });
    }
    this.setState({
      ids,
      suppliers,
      shopList,
      selectProducts,
      selectedAll,
      emptyStatus: shopList.length ? '' : 'shopCart',
      loading: false,
      erpMap: newErpMap
    }, () => {
      // let doms = document.getElementsByClassName('bottom');
      // if (doms && doms.length) {
      //   let bottomBarTop = document.getElementsByClassName('bottom')[0].getBoundingClientRect().top;
      //   let cHeight = document.documentElement.clientHeight;
      //   this.setState({
      //     fixedBottom: bottomBarTop >= (cHeight - 64) ? true : false
      //   });
      // }
      this.computeTotal();
    });
  }
  init = async () => {
    const params = new URLSearchParams(this.props.location.search);
    const pre_sale_goods_id = params.get('id'), order_no = params.get('orderId');
    this.setState({ pre_sale_goods_id, order_no });
    const { data: { data = {}, error, code } } = await orderPlanTaskReserveListAddress({ pre_sale_goods_id, order_no });
    if (+code === 0) {
      const { list = [], plan = {} } = data;
      const products = planFormateProducts(list);
      const finallyFormateProducts = planMapState(planModifyProductNum({ products: {}, ids: [], cartIds: [], sellers: {}, sellerIds: [] }, products, false));
      this.finallyFormatProduct(finallyFormateProducts);
      this.setState({ plan });
    } else {
      message.error(error, .5, history.back());
    }
  }
  async componentDidMount() {
    this.init();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }
  forMateErpMap(list = [], map = {}) {
    const erpMap = {};
    for (const item of list) {
      const { supplierId, saleList, isRelation } = item;
      const mappingProducts = saleList.filter(item => !item.is_mapping);
      const selfIds = mappingProducts.map(item => ({ norms_id: item.norms_id }));
      const isMapping = !!mappingProducts.length;
      if ((isMapping || !isRelation) && !map[supplierId]?.isFinished) {
        erpMap[supplierId] = map[supplierId] ? { ...map[supplierId], mappingProducts, isMapping } : {
          supplierId,
          mappingProducts,
          isMapping,
          mapRef: createRef(),
          isRelation,
          expand: false,//折叠开关
          isFinished: false,//是否完成校验
          erpMapData: {},
          selfIds
        };
      }
    }
    for (let i in erpMap) {
      const { selfIds, isFinished } = erpMap[i];
      const formateIds = selfIds.map(item => ({ ...item, isFinished }));
      erpMap[i].formateIds = formateIds;
    }
    return erpMap;
  }


  submitPlanOrder = () => {
    this.submit(2);
  }

  submitOrder = () => {
    this.submit(1);
  }

  submit = (type) => {
    const { plan = {} } = this.state;
    const { domestic_transport_type, abroad_transport_type } = plan;

    let keys = Object.keys(this.state.selectProducts);
    if (keys.length <= 0) {
      message.info('请先选择商品');
      return;
    }


    let formatSelectProducts = {};

    for (let i in this.state.selectProducts) {
      formatSelectProducts[i] = { ...this.state.selectProducts[i], domestic_transport_type, abroad_transport_type };
    }
    localStorage.setItem('orderData', JSON.stringify(formatSelectProducts));
    const { selectProducts, erpMap, addressId } = this.state;
    const formateSelectProducts = Reflect.ownKeys(selectProducts);
    const arr = [];
    for (let i in erpMap) {
      arr.push(...erpMap[i].formateIds);
    }
    const result = formateSelectProducts.filter(item => {
      return (arr.filter(subItem => {
        if (String(subItem.norms_id) === String(item)) {
          return !subItem.isFinished;
        } else {
          return '';
        }
      })).length;

    });
    if (result.length) {
      message.error('选择的商品包含不完整的erp信息，请完成后重试');
    } else {
      this.props.history.push(`/basic/plan/submit?${queryString({ type, addressId })}`);
    }
  }

  add = (product) => {
    const { num, stock_cur_num, sale_max_count_day } = product;
    let max = +(sale_max_count_day) === 0 ? +(stock_cur_num) : (+(stock_cur_num) < +(sale_max_count_day)) ? +(stock_cur_num) : +(sale_max_count_day);
    if (num >= max) {
      message.info('超过最大可购买量，不能再加了');
      return;
    }
    this.props.addProduct(product);
  }

  reduce = (product) => {
    const { num, sale_min_count, norms_id } = product;
    if (num <= +(sale_min_count)) {
      message.info('商品数量不能再减少了');
      return;
    }
    this.props.reduceProduct(norms_id);
  }

  inputChanged = (e, product) => {
    let value = e.target.value;
    value = Number(value.replace(/\D/g, ''));
    let currentProduct = Object.assign({}, product, { num: value });
    this.setState({
      currentProduct
    });
  }

  onBlur = (e, product) => {
    let value = e.target.value;
    value = Number(value.replace(/\D/g, ''));
    this.setState({
      currentProduct: {}
    });
    if (isNaN(value)) {
      message.info('请输入有效数字');
      return;
    }
    if (!product) { return; }
    const { stock_cur_num, sale_max_count_day, sale_min_count } = product;
    let max = +(sale_max_count_day) === 0 ? +(stock_cur_num) : (+(stock_cur_num) < +(sale_max_count_day)) ? +(stock_cur_num) : +(sale_max_count_day);
    if (value > max) {
      value = max;
      message.info('超过最大可购买量');
    }
    if (value < +(sale_min_count)) {
      message.info('商品数量不能小于最小起订量');
      return;
    }
    this.props.modifyProduct(product, value);
  }

  removeProduct = (product) => {
    this.updateCheckChecked(product);
    this.props.removeProduct(product.norms_id, product.cartId);
    this.props.initShopCart();
  }

  removeProducts = () => {
    if (this.state.selectedAll) {
      this.props.clearProduct();
    } else {
      let { selectProducts } = this.state;
      let { products } = this.props;
      let keys = Object.keys(selectProducts);
      if (!keys.length) { return; }

      let cartIds = (Object.values(selectProducts) || []).map(obj => {
        return obj.cartId;
      });

      keys.forEach(key => {
        this.updateCheckChecked(products[key]);
      });

      this.props.removeProduct(keys, cartIds);
    }
    this.props.initShopCart();
  }

  updateCheckChecked(product) {
    let { supplier_id, norms_id } = product;
    let { selectProducts, suppliers } = this.state;

    let item = suppliers[supplier_id];

    if (selectProducts[norms_id]) {
      delete selectProducts[norms_id];
      item.checkNum -= 1;
      item.productNum -= 1;
      item.checked = item.checkNum === item.productNum;
    } else {
      item.productNum -= 1;
      item.checked = item.checkNum === item.productNum;
    }
    suppliers[supplier_id] = item;

    this.setState({
      selectProducts,
      suppliers,
    }, () => {
      this.computeTotal();
    });
  }

  supplierChecked = (e, item) => {
    let checked = e.target.checked;
    let { supplierId, saleList = [] } = item;
    let { selectProducts, suppliers } = this.state;
    let selectedAll = false;
    let addressId = '';
    if (checked) {
      Object.values(suppliers).forEach(obj => {
        obj.checkNum = 0;
        obj.checked = false;
      });
      selectProducts = {};
      suppliers[supplierId] = {
        checkNum: saleList.filter(item => item.qoute_id).length,
        productNum: saleList.filter(item => item.qoute_id).length,
        checked: true
      };
      saleList.filter(item => item.qoute_id).forEach(product => {
        selectProducts[product.norms_id] = {
          number: product.num,
          total: product.num * amountStrToNumber(product.unit_amount),
          checked: true,
          isOnSale: product.is_on_sale,
          cartId: product.cartId,
          saleId: product.id,
          unit: product.unit,
          pre_sale_goods_id: product.pre_sale_goods_id,
          tax_inclusive_subtotal: product.tax_inclusive_subtotal,
          qoute_id: product.qoute_id,
        };
        addressId = product.addressId;
      });
    } else {
      addressId = '';
      saleList.filter(item => item.qoute_id).forEach(product => {
        delete selectProducts[product.norms_id];
      });
      suppliers[supplierId] = {
        checkNum: 0,
        productNum: saleList.filter(item => item.qoute_id).length,
        checked: false
      };
    }
    this.setState({
      selectProducts,
      suppliers,
      selectedAll,
      addressId
    }, () => {
      this.computeTotal();
    });
  }

  productChecked = (e, product) => {
    const checked = e.target.checked;
    let { supplier_id, norms_id, addressId } = product;
    let { selectProducts, suppliers } = this.state;
    let selectedAll = false;
    const uniqueKey = `${supplier_id}-${addressId}`;
    const keys = Reflect.ownKeys(suppliers);
    const condition = keys.filter(item => (item !== uniqueKey) && suppliers[item].checked).length;
    if (checked) {
      if (condition) {
        Object.values(suppliers).forEach(obj => {
          obj.checkNum = 0;
          obj.checked = false;
        });
        selectProducts = {};
      }
      selectProducts[norms_id] = {
        number: product.num,
        total: product.num * amountStrToNumber(product.unit_amount),
        checked: true,
        isOnSale: product.is_on_sale,
        cartId: product.cartId,
        saleId: product.id,
        unit: product.unit,
        pre_sale_goods_id: product.pre_sale_goods_id,
        tax_inclusive_subtotal: product.tax_inclusive_subtotal,
        qoute_id: product.qoute_id,
      };
      let item = suppliers[uniqueKey];
      item.checkNum += 1;
      item.checked = item.checkNum === item.productNum;
      suppliers[uniqueKey] = item;
    } else {
      delete selectProducts[norms_id];
      let item = suppliers[uniqueKey];
      item.checkNum -= 1;
      item.checked = item.checkNum === item.productNum;
      suppliers[uniqueKey] = item;
      addressId = '';
    }
    this.setState({
      selectProducts,
      suppliers,
      selectedAll,
      addressId
    }, () => {
      this.computeTotal();
    });
  }

  selectedAll = (e) => {
    let checked = e.target.checked;
    let { selectProducts, suppliers, shopList } = this.state;
    if (checked) {
      shopList.forEach(obj => {
        suppliers[obj.supplierId] = {
          checkNum: obj.saleList.filter(item => item.qoute_id).length,
          productNum: obj.saleList.filter(item => item.qoute_id).length,
          checked: true
        };
        obj.saleList.filter(item => item.qoute_id).forEach(product => {
          selectProducts[product.norms_id] = {
            number: product.num,
            total: product.num * amountStrToNumber(product.unit_amount),
            checked: true,
            isOnSale: product.is_on_sale,
            cartId: product.cartId,
            saleId: product.id,
            unit: product.unit,
            pre_sale_goods_id: product.pre_sale_goods_id,
            tax_inclusive_subtotal: product.tax_inclusive_subtotal,
            qoute_id: product.qoute_id,
          };
        });
      });
    } else {
      Object.values(suppliers).forEach(obj => {
        obj.checkNum = 0;
        obj.checked = false;
      });
      selectProducts = {};
    }

    this.setState({
      selectProducts,
      suppliers,
      selectedAll: checked
    }, () => {
      this.computeTotal();
    });
  }

  computeTotal = () => {
    let totalCount = 0;
    let totalPrice = 0;
    let { selectProducts } = this.state;
    let values = Object.values(selectProducts);
    totalCount = values.length;
    values.forEach(obj => {
      totalPrice += (+obj.tax_inclusive_subtotal);
    });

    this.setState({
      totalCount,
      totalPrice: amountToString(totalPrice)
    });
  }

  toProductDetail = (product) => {
    const { spu_id, supplier_id, norms_id } = product;
    if (!spu_id || !supplier_id || !norms_id) {
      message.info('商品缺少spu_id或norms_id或supplier_id');
      return;
    }
    this.props.history.push('/basic/product/detail/' + spu_id + '/' + supplier_id + '/' + norms_id);
  }

  searchTypeChanged = (value) => {
    this.setState({
      searchType: value
    });
  }

  searchValueChanged = (value) => {
    this.setState({
      searchValue: value
    });
  }

  openErpForm = item => {
    const { erpMap = {} } = this.state;
    const { supplierId } = item;
    const currentMap = erpMap[supplierId];
    const { expand, mapRef } = currentMap;
    if (expand) {//即将关闭
      erpMap[supplierId]['erpMapData'] = mapRef?.form?.getFieldsValue() || {};
    }
    erpMap[supplierId]['expand'] = !expand;
    this.setState({ erpMap });
  }

  erpMapSubmit = async values => {
    const { supplierId, ...value } = values;
    const { erpMap = {} } = this.state;
    const { expand, isRelation, mappingProducts = [] } = erpMap[supplierId];
    const { rel_company_name, primary_code, sub_code, ...productsMap } = value || {};
    const postData = {};
    if (!isRelation) {
      postData["relation"] = { rel_company_id: supplierId, rel_company_name, primary_code, sub_code };
    }
    if (mappingProducts.length) {
      postData['mapping'] = mappingProducts.map(item => {
        const { sale_id, base_unit, sku_no } = item;
        return {
          out_prop: productsMap[`out_prop_${sale_id}`],
          out_unit: productsMap[`out_unit_${sale_id}`],
          out_sku_no: productsMap[`out_sku_no_${sale_id}`],
          base_unit,
          sku_no
        };
      });
    }
    const { data: { code, msg } } = await send({ url: '/ipp/order-purchase/relation-mapping', method: 'POST', data: postData });

    if (+code === 0) {
      erpMap[supplierId]['expand'] = !expand;
      erpMap[supplierId]['isFinished'] = true;
      message.success(msg, .5, this.setState({ erpMap }));
      this.init();
    } else {
      message.error(msg);
    }
  }

  erpMapCancel = async values => {
    const { supplierId } = values;
    const { erpMap = {} } = this.state;
    const currentMap = erpMap[supplierId];
    const { mapRef } = currentMap;
    const erpMapData = formateErpProducts(currentMap);
    for (let item in erpMapData) {
      erpMapData[item] = '';
    }
    mapRef.form.setFieldsValue(erpMapData);
    erpMap[supplierId]['expand'] = false;
    this.setState({ erpMap });
  }

  render() {
    const { shopList = [], fixedBottom=true, selectProducts, suppliers, selectedAll, totalCount, totalPrice, emptyStatus, loading, searchValue = '', searchType = '1', erpMap = {}, plan = {} } = this.state;

    const header = (
      <div className="transfer-cart-top">
        <CpLogo />
        <div style={{ marginLeft: '40px' }}>
          <CpSearchBar
            searchValue={searchValue}
            searchType={searchType}
            searchValueChanged={this.searchValueChanged}
            searchTypeChanged={this.searchTypeChanged} />
        </div>
      </div>
    );

    const empty = (
      <div className="cart-empty">
        <CpEmpty status={emptyStatus} history={this.props.history} />
      </div>
    );

    const { order_no, task_name, task_start_time, task_end_time, plan_start_time, plan_end_time, release_time, domestic_transport_type, abroad_transport_type } = plan;
    const customLength = 10;
    const condition = task_name?.length > customLength;
    return (
      <div className="transfer-cart">
        {header}
        <div className='transfer-cart-header-container'>
          <Row>
            <Col span={8}>计划编码：{order_no}</Col>
            <Col span={8} ><Tooltip title={task_name}>计划名称：{condition ? task_name?.slice(0, customLength) + '...' : task_name}</Tooltip></Col>
          </Row>
          <Row>
            <Col span={8}>国际运输方式：{TransportationType[+abroad_transport_type]}</Col>
            <Col span={8}>国内运输方式：{TransportationType[+domestic_transport_type]}</Col>
          </Row>
          <Row>
            <Col span={8}>计划收集周期：{moment(task_start_time * 1000).format('YYYY-MM-DD')}~{moment(task_end_time * 1000).format('YYYY-MM-DD')}</Col>
            <Col span={8}>采购周期：{moment(plan_start_time * 1000).format('YYYY-MM-DD')}~{moment(plan_end_time * 1000).format('YYYY-MM-DD')}</Col>
            <Col span={8}>计划发布日期：{moment(release_time * 1000).format('YYYY-MM-DD')}</Col>
          </Row>
        </div>
        {(shopList?.length <= 0 && emptyStatus?.length) ? empty :
          <div className="transfer-cart-content">
            {loading ? <CpLoading className="cp-loading" /> : null}
            <div className="transfer-cart-list">
              <table className="cp-table">
                <thead>
                  <tr>
                    {
                      this.columns.map((item, index) => {
                        return (
                          <th key={index} colSpan={item.colSpan || 1} style={{ textAlign: item.align, width: item.width }}>
                            {item.key === 'selectState' ? null : (<>{index === 0 && (<Checkbox style={{ margin: '0px 12px' }} checked={selectedAll} onChange={this.selectedAll}></Checkbox>)}{item.name} </>)}
                          </th>
                        );
                      })
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    (shopList || [])?.map((item, index) => {
                      return (
                        <Fragment key={index}>
                          <tr>
                            <td colSpan={this.columns.length} className="td-group">
                              <div className='transfer-cart-table-provider'>
                                <div>
                                  <Checkbox style={{ margin: '0px 12px' }} checked={suppliers[item.supplierId] ? suppliers[item.supplierId].checked : false} onChange={(e) => { this.supplierChecked(e, item); }}></Checkbox>供应商：{item.supplierName}
                                </div>
                                <div>收货地址：{item.addressDetail}</div>
                                {
                                  !erpMap[item.supplierId]?.['isFinished'] ? <div>
                                    {/* {erpMap[item.supplierId]?.expand ? <Typography.Link className='transfer-cart-table-provider-erp-tip'><InfoCircleOutlined />请添加ERP供应商或商品映射</Typography.Link> : null} */}
                                    {erpMap[item.supplierId] ? <><Typography.Link className='transfer-cart-table-provider-erp-tip' onClick={() => this.openErpForm(item)}><InfoCircleOutlined />请添加ERP供应商映射</Typography.Link></> : null}
                                  </div> : null
                                }
                              </div>
                              {
                                erpMap[item.supplierId]?.expand ?
                                  <ErpMapForm
                                    currentMap={erpMap[item.supplierId]}
                                    ref={el => erpMap[item.supplierId].mapRef = el}
                                    erpMapSubmit={this.erpMapSubmit}
                                    erpMapCancel={this.erpMapCancel}
                                  />
                                  : null
                              }
                            </td>
                          </tr>
                          {
                            item.saleList.map((p, idx) => {
                              return (
                                <tr key={idx} style={{ background: p.current ? '#efefef' : '', position: 'relative', }}>
                                  {
                                    this.columns.map((col, index) => {
                                      if (col.key === 'selectState') {
                                        return null;
                                      } else if (col.key === 'product') {
                                        return (
                                          <td key={index} colSpan={2} style={{ width: p.width }}>
                                            <div className="product-info">
                                              <Checkbox className="product-checked" disabled={!p.qoute_id} checked={selectProducts[p.norms_id] ? selectProducts[p.norms_id].checked : false} onChange={(e) => { this.productChecked(e, p); }} ></Checkbox>
                                              <CpProductInfo product={p} toProductDetail={() => { this.toProductDetail(p); }} />
                                            </div>
                                          </td>
                                        );
                                      } else if (col.key === 'num') {
                                        return (
                                          <td key={index} style={{ textAlign: 'center', width: col.width }}>
                                            <div className="countContainer">{p.num}</div>
                                          </td>
                                        );
                                      } else if (col.key === 'action') {
                                        return (
                                          <td key={index} style={{ textAlign: 'center', width: col.width }}>
                                            <Popconfirm
                                              title="确定要删除商品吗?"
                                              onConfirm={() => this.removeProduct(p)}
                                              okText="确认"
                                              cancelText="取消"
                                            >
                                              <span className='pointer'>删除</span>
                                            </Popconfirm>
                                          </td>);
                                      } else if (col.key === 'tax_inclusive_subtotal') {
                                        return (<td key={index} style={{ textAlign: 'right', fontWeight: '600', width: col.width }}>￥{amountToString(p.tax_inclusive_subtotal)}</td>);
                                      } else if (col.key === 'tax_rate') {
                                        return (<td key={index} style={{ textAlign: 'right', fontWeight: '600', width: col.width }}>{p.tax_rate >= 0 ? (+p.tax_rate + '%') : '-'}</td>);
                                      } else if (col.key === 'tax_inclusive_price') {
                                        return (<td key={index} style={{ textAlign: 'right', fontWeight: '600', width: col.width }}>
                                          {p.tax_inclusive_price === '-' ? '' : <>￥{amountToString(p.tax_inclusive_price)}</>}
                                        </td>);
                                      } else {
                                        return (
                                          <td key={index} style={{ textAlign: 'right', fontWeight: '600', width: col.width }}>￥{p[col.key]}</td>);
                                      }
                                    })
                                  }
                                  {
                                    !p.qoute_id ? <td className='disable-product' key={idx}>
                                      <div><span className='disable-product-tip'>已作废</span></div>
                                    </td> : null
                                  }
                                </tr>
                              );
                            })
                          }
                        </Fragment>
                      );
                    })
                  }
                </tbody>
              </table>
            </div>
            {
              fixedBottom && (<div className="whitespace"></div>)
            }
            {
              (shopList || [])?.length <= 0 ? null :
                <div className={fixedBottom ? 'bottom fixed-bottom' : 'bottom'}>
                  <div className="bottom-content">
                    <div className="bottom-right">
                      <div className="bottom-select-count">已选择<span className="bottom-select-count-value">{totalCount}</span>件商品</div>
                      <div className="bottom-select-price">总价：<span className="bottom-select-price-value">￥{totalPrice}</span></div>
                      {/* <Button className="bottom-submit-plan" onClick={this.submitPlanOrder}>提交计划单</Button> */}
                      <Button className="bottom-submit-settlement" onClick={this.submitOrder}>去结算</Button>
                    </div>
                  </div>
                </div>
            }
          </div>
        }
      </div>
    );
  }
}